import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OidcClientService } from '@upmc-healthplan-npm/oidc-client';
import { Subject, Observable, Subscriber } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EpHttpService } from 'src/app/shared/services/epHttpService/epHttp.service';
import { EpEnvironmentService } from 'src/app/shared/services/epEnvironmentService/ep-environment.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  // can't use angular route fragment because it
  // causes an infinite loop in IE11
  window = (window as any);
  unsubscribe = new Subject();
  brokerRoleUrl = `${EpEnvironmentService.baseUrl}EmployerPlace/api/users/userclaims`;

  constructor(
    private auth: OidcClientService,
    private httpService: EpHttpService,
    private route: ActivatedRoute
  ) { }

  signIn() {
    return new Observable(observer => {
      this.auth.getUserComputed()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(user => {
          if (!user || this.auth.isExpired()) {
            // grabs hash value from sso and strips out the authentication token
            const hash = this.window.location.hash; // salesforce sso
            const idToken = this.route.snapshot.queryParamMap.get('id_token'); // producer portal sso
            if (hash && hash.includes('id_token=')) {
              const authTokenIndex = hash.indexOf('id_token=');
              const authToken = hash.substring(authTokenIndex + 9); // strip everything but the token
              this.createSignIn(authToken, observer);
            } else if (idToken) {
              this.createSignIn(idToken, observer);
            } else {
              observer.next(false);
            }
          } else {
            observer.next(true);
          }
        });
    });
  }

  createSignIn(token: string, observer: Subscriber<any>) {
    this.auth.createSignInFromIdToken(token).pipe(
      takeUntil(this.unsubscribe)
    ).subscribe(state => {
      const uri = `/#state=${state}&id_token=${token}`;
      this.completeSignIn(uri, observer);
    });
  }

  completeSignIn(uri: string, observer: Subscriber<any>) {
    this.auth.completeSignIn(uri).subscribe(signedInUser => {
      if (signedInUser) {
        this.httpService.request('GET', this.brokerRoleUrl)
          .pipe(
            takeUntil(this.unsubscribe)
          ).subscribe(
            data => {
              sessionStorage.setItem('userRole', JSON.stringify(data));
              observer.next(true);
              this.unsubscribe.next(true);
            },
            _ => observer.next(false)
          );
      } else {
        observer.next(false);
      }
    });
  }
}
